import React from "react";
import { withRouter } from "react-router";
import postLandingPage from "./utils/Analytics";
import logo from "./assets/images/zyla.svg";
import undo from "./assets/images/undo.svg";
import send from "./assets/images/ic_send.png";
import sendGrey from "./assets/images/ic_send_grey_3.png";
import Loading from "./Components/Loading";
import RequestCallback from "./Components/RequestCallback";
import "./App.css";
import ChatBotServices from "./services/chatBotServices";

let initialMessages = [
  {
    id: 106,
    question:
      "Hey, I’m Zyla, your personal healthcare expert! I’m here to help you focus on your health with a quick analysis followed by your Health Risk Score.",
    fields: [],
    type: 5,
    answer: null,
    undo: null,
  },

  {
    id: 109,
    question: "Are you ready?",
    fields: [
      {
        type: 2,
        validate: "",
        text: " Yes, lets do it now",
        tag: "yes",
      },
      {
        type: 2,
        validate: "",
        text: " No, I will do it later",
        tag: "no",
      },
    ],
    type: 2,
    answer: null,
    undo: null,
  },
  {
    id: 110,
    question: "Awesome",
    fields: [],
    type: 5,
    answer: null,
    undo: null,
  },
  {
    id: 111,
    question:
      "We are ISO27001 compliant hence all your data shall remain confidential and won’t be shared with anyone, including your employer. Write to us at care@zyla.in anytime and we’ll address your concerns right away. 🙂",
    fields: [],
    answer: null,
    type: 5,
    undo: null,
  },

  {
    id: 113,
    question:
      "To start with, please enter your corporate email ID for verification.",
    fields: [
      {
        type: 1,
        validate: "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$",
        text: "",
        placeholder: "Type Here",
      },
    ],
    type: 1,
    answer: null,
    undo: true,
  },
];
let initialMessagesDone = [
  {
    id: 100,
    question:
      "Hey, I’m Zyla, your personal healthcare expert! I’m here to help you focus on your health with a quick analysis followed by your Health Risk Score.",
    fields: [],

    answer: null,
    type: 5,
    undo: true,
  },
  {
    id: 103,
    question: "Are you ready?",
    fields: [
      {
        type: 2,
        validate: "",
        text: " Yes, lets do it now",
        tag: "yes",
      },
      {
        type: 2,
        validate: "",
        text: " No, I will do it later",
        tag: "no",
      },
    ],
    answer: " Yes, lets do it now",
    undo: true,
  },
  {
    id: 104,
    question: "Awesome",
    fields: [],

    answer: null,
    type: 5,
    undo: true,
  },
  {
    id: 105,
    question:
      "We are ISO27001 compliant hence all your data shall remain confidential and won’t be shared with anyone, including your employer. Write to us at care@zyla.in anytime and we’ll address your concerns right away.🙂",
    fields: [],
    answer: null,

    type: 5,
    undo: true,
  },
];

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showRequestCallback: false,
      inputValue: "",
      messages: [],
      loading: true,
      email: null,
      otp: false,
      hasError: false,
      errorMessage: "Oops Something went wrong",
      isInput: false,
    };
    this.chatBotService = new ChatBotServices();
    this.msgBox = React.createRef();
    this.messagesEnd = React.createRef();
    this.validation = "";
    this.inputTag = "";
    this.placeholder = "";
    this.defaultMsg = "Looks like Something went wrong on our end";
    // window.addEventListener("unload", function (e) {
    //   window.scrollTo(0, 0);
    // });
  }
  componentDidMount() {
    this.disableInput();
    let url = window.location.search;
    let searchParams = new URLSearchParams(url);
    postLandingPage(50, searchParams);
    if (
      localStorage.getItem("slug") === null &&
      searchParams.has("idToken") === false
    ) {
      setTimeout(() => {
        const messages = this.state.messages;
        this.setState({
          messages: [...messages, { ...initialMessages[0] }],
        });
      }, 1000);

      setTimeout(() => {
        const messages = this.state.messages;
        this.setState(
          {
            messages: [...messages, { ...initialMessages[1] }],
            loading: false,
          },
          () => this.scrollToBottomInitial()
        );
      }, 4000);
    } else {
      let header = { client: "web" };
      if (searchParams.has("idToken") === true) {
        header.auth_token = searchParams.get("idToken");
        header.phone_no = searchParams.get("user_id");
      } else {
        header.auth_token = localStorage.getItem("slug");
      }
      this.chatBotService.getEmail(
        header,
        (res) => {
          let welcomeMsg = {
            id: 11,
            type: 5,
            question: `Welcome Back ${res.email}`,
            undo: null,
          };
          localStorage.setItem("slug", res.slug);

          this.chatBotService.getAllAnswers(
            localStorage.getItem("slug"),
            (response) => {
              if (response.completed === true) {
                this.props.history.push("/score");
              } else {
                let finalList = [];
                initialMessagesDone.forEach((ele) => {
                  finalList.push({ ...ele });
                });
                let msgList = response.questions.map((ele) => {
                  return { ...ele };
                });
                msgList.forEach((ele) => {
                  let cheery = this.getCheeryMessages({ ...ele });
                  ele.cheery = cheery;
                });
                finalList.push(welcomeMsg);
                this.setState(
                  { messages: [...finalList, ...msgList], email: res.email },
                  () => this.getNext()
                );
              }
            },
            (error) => {
              console.log("cannot retrieve all the qanswered questions");
            }
          );
        },
        (error) => {
          console.log("error is ", error);
          this.handleError(error.message);
        }
      );
    }
  }
  disableInput = () => {
    let ele = document.getElementById("my-input-box");
    ele.disabled = true;
    ele.classList.add("disabled-box");
    document.getElementById("send-img").src = sendGrey;
  };
  enableInput = () => {
    let ele = document.getElementById("my-input-box");
    ele.disabled = false;
    ele.classList.remove("disabled-box");
    document.getElementById("send-img").src = send;
  };
  handleInput = (e) => {
    this.setState({ inputValue: e.target.value });
  };
  handleBubbleMessage = (e, bubble_tag) => {
    this.setState({ loading: true });
    this.disableInput();

    let msg = { ...this.state.messages[this.state.messages.length - 1] };
    msg.answer = e.target.innerText;
    let msgList = this.state.messages.map((ele) => {
      return { ...ele };
    });
    msgList.pop();
    let cheery = this.getCheeryMessages({ id: msg.id });
    msg.cheery = cheery;
    msgList.push(msg);
    this.setState({ messages: [...msgList] });
    let slug = localStorage.getItem("slug");
    let params = {
      id: msg.id,
      answer: e.target.innerText,
      answerTag: bubble_tag,
    };

    this.chatBotService.submitAnswer(
      slug,
      params,
      (res) => {
        this.getNext();
      },
      (err) => {
        console.log("cannot sbmit the answer");
      }
    );
  };
  getNext = () => {
    this.chatBotService.getNextQuestion(
      localStorage.getItem("slug"),
      (res) => {
        if (res.completed === true) {
          let thankyouMsg = {
            id: 11,
            type: 5,
            question:
              "I have analysed the data you shared and here is your result for your record. 🙂",
          };
          let msgList = this.state.messages.map((ele) => {
            return { ...ele };
          });
          msgList.push(thankyouMsg);
          this.setState({ messages: [...msgList], loading: false }, () =>
            this.props.history.push("/score")
          );
          return;
        }
        let myVal = false;
        let quesObj = { ...res.currentQuestion };
        quesObj.answer = null;
        let fieldarr = res.currentQuestion.fields.map((ele) => {
          if (ele.type === 1) {
            myVal = true;
          }
          return { ...ele };
        });
        if (myVal) {
          this.enableInput();
        }
        quesObj.fields = fieldarr;
        let msgList = this.state.messages.map((ele) => {
          return { ...ele };
        });
        msgList.push(quesObj);
        this.setState({ messages: [...msgList], loading: false }, () =>
          this.scrollToBottomInitial()
        );
      },
      (err) => {
        console.log("cannot fetch the next question");
      }
    );
  };
  sendMessage = (e) => {
    e.preventDefault();

    if (this.state.inputValue.length === 0) {
      return;
    }

    this.disableInput();

    this.setState({ loading: true }, () => this.scrollToBottomInitial());
    if (this.state.email === null) {
      let url = window.location.search;
      let urlParams = new URLSearchParams(url);
      this.chatBotService.getOTP(
        this.state.inputValue,
        {
          utm1: urlParams.get("utm1") || "",
          utm2: urlParams.get("utm2") || "",
          utm3: urlParams.get("utm3") || "",
        },
        (otp) => {
          let msg = {
            id: 9,
            question:
              "Kindly share the 4 digit OTP sent to your mentioned email ID",
            fields: [{ type: 1, validation: "" }],
            answer: null,
          };
          let msgList = this.state.messages.map((ele) => {
            return { ...ele };
          });
          let Obj = { ...msgList[msgList.length - 1] };
          Obj.answer = this.state.inputValue;
          msgList.pop();
          msgList.push(Obj);
          msgList.push(msg);

          this.setState(
            {
              messages: [...msgList],
              loading: false,
              inputValue: "",
              email: Obj.answer,
              otp: true,
            },
            () => this.scrollToBottomInitial()
          );
          this.enableInput();
        },
        (err) => {
          this.scrollToBottomInitial();
          this.setState({ loading: false }, () => {
            if (err.message === "DOMAIN_NOT_FOUND") {
              this.handleError(
                "Please enter your corporate email id to get your Health Risk Score. Reach out to us on 9818-111-918 to talk to our medical expert."
              );
            } else {
              this.handleError("Please enter a valid email Id");
            }
            this.enableInput();
          });
          console.log("error is ", err.message);
        }
      );

      return;
    }
    if (this.state.otp) {
      let val = this.state.inputValue;
      if (val.length !== 4) {
        this.setState({ loading: false });
        this.handleError("Please enter a valid otp");
        this.enableInput();
        return;
      } else {
        this.chatBotService.verifyOTP(
          {
            email: this.state.email,
            otp: parseInt(this.state.inputValue),
          },
          (res) => {
            let msgList = this.state.messages.map((ele) => {
              return { ...ele };
            });
            let Obj = { ...msgList[msgList.length - 1] };

            Obj.answer = val;
            msgList.pop();

            msgList.push(Obj);

            this.chatBotService.getAllAnswers(
              res.user.slug,
              (response) => {
                if (response.completed === true) {
                  localStorage.setItem("slug", res.user.slug);
                  this.props.history.push("/score");
                } else if (response.questions.length === 0) {
                  let msg = {
                    id: 10,
                    question: "Great, let's start with a few basic details",
                    fields: [],
                    answer: null,
                    undo: null,
                  };

                  msgList.push(msg);
                  this.setState(
                    {
                      otp: false,
                      messages: [...msgList],
                      inputValue: "",
                    },
                    () => {
                      localStorage.setItem("slug", res.user.slug);
                      // this.scrollToBottom();
                      this.getNext();
                    }
                  );
                } else {
                  let welcomeMsg = {
                    id: 11,
                    type: 5,
                    question: `Welcome Back ${this.state.email}`,
                    undo: null,
                  };
                  // let finalList = [];
                  // initialMessagesDone.forEach((ele) => {
                  //   finalList.push({ ...ele });
                  // });
                  let msgList2 = response.questions.map((ele) => {
                    return { ...ele };
                  });
                  msgList2 = [welcomeMsg, ...msgList2];
                  msgList2.forEach((ele) => {
                    let cheery = this.getCheeryMessages({ ...ele });
                    ele.cheery = cheery;
                  });
                  msgList2.forEach((msg) => {
                    msgList.push(msg);
                  });
                  this.setState(
                    {
                      otp: false,
                      messages: [...msgList],
                      inputValue: "",
                    },
                    () => {
                      localStorage.setItem("slug", res.user.slug);
                      // this.scrollToBottom();
                      this.getNext();
                    }
                  );
                }
              },
              (err) => {
                console.log("An error occured");
              }
            );
          },
          (err) => {
            this.handleError("Please enter a valid otp");
            this.enableInput();
            console.log("error is ", err);
          }
        );
        return;
      }
    }
    let re = new RegExp(this.validation);
    console.log("validation is ", re, re.test(this.state.inputValue));
    if (!re.test(this.state.inputValue)) {
      this.handleError("Please Enter a valid input");
      this.enableInput();
      return;
    }
    let msg = { ...this.state.messages[this.state.messages.length - 1] };
    // msg.answer =
    //   this.state.inputValue +
    //   this.state.messages[this.state.messages.length - 1].fields[0].text;
    let msgList = this.state.messages.map((ele) => {
      return { ...ele };
    });
    // msgList.pop();
    // msgList.push(msg);
    // this.setState({ messages: [...msgList], inputValue: "" });
    let slug = localStorage.getItem("slug");
    let params = {
      id: msg.id,
      answer: this.state.inputValue,
      answerTag: this.inputTag,
    };

    this.chatBotService.submitAnswer(
      slug,
      params,
      (res) => {
        msg.answer = res.answer;
        msgList.pop();
        let cheery = this.getCheeryMessages(params);
        msg.cheery = cheery;
        msgList.push(msg);
        this.setState({ messages: [...msgList], inputValue: "" });
        this.getNext();
      },
      (err) => {
        console.log("cannot submit the answer");
      }
    );
    this.setState({ inputValue: "", messages: msgList });
  };
  handleUndo = () => {
    if (localStorage.getItem("slug") === null) {
      let msgList = this.state.messages.map((ele) => {
        return { ...ele };
      });
      msgList.pop();
      msgList.pop();
      console.log("current msg List is", msgList, initialMessages[7]);
      this.setState(
        {
          messages: [...msgList, { ...initialMessages[7] }],
          loading: false,
          otp: false,
          email: null,
        },
        () => this.scrollToBottomInitial()
      );
      return;
    }
    let msgList = this.state.messages.map((ele) => {
      return { ...ele };
    });
    if (msgList[msgList.length - 2].undo) {
      msgList.pop();
      this.setState({ messages: [...msgList] }, () => this.getNext());

      return;
    }
    let id = msgList[msgList.length - 2].id;
    msgList.pop();
    msgList.pop();
    this.disableInput();
    this.chatBotService.undoQuestion(
      localStorage.getItem("slug"),
      {
        id: id,
      },
      (res) => {
        this.setState({ messages: [...msgList], inputValue: "" }, () => {
          this.getNext();
        });
      },
      (err) => {
        console.log("cannot undo the question");
      }
    );
    this.setState({ messages: msgList });
  };
  handleError = (msg) => {
    this.setState({ hasError: true, errorMessage: msg, loading: false }, () => {
      setTimeout(() => {
        this.setState({ hasError: false, errorMessage: this.defaultMsg }, () =>
          this.scrollToBottomInitial()
        );
      }, 5000);
    });
  };

  scrollToBottomInitial = () => {
    let bounding = this.messagesEnd.current.getBoundingClientRect();

    if (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <=
        (window.innerHeight - 68 || document.documentElement.clientHeight - 68)
    ) {
    } else {
      if (this.messagesEnd) {
        this.messagesEnd.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  };

  scrollToBottom = () => {
    if (this.messagesEnd) {
      this.messagesEnd.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  scrollOnFocus = () => {
    let val = document.getElementsByClassName("message-box")[0]?.scrollHeight;

    setTimeout(() => {
      if (this.messagesEnd) {
        this.messagesEnd.current.scrollIntoView({ behavior: "smooth" });
      } else {
        document
          .getElementsByClassName("message-box")[0]
          ?.scrollTo(0, val + 10000);
      }
    }, 400);
  };

  handleInitialBubbleMessage = (tag) => {
    let msgList = this.state.messages.map((ele) => {
      return { ...ele };
    });
    let Obj = msgList[msgList.length - 1];
    Obj.answer =
      tag === "yes" ? "Yes, lets do it now" : "No, I will do it later";
    msgList.pop();
    msgList.push(Obj);
    this.setState({ messages: msgList, loading: true }, () => {
      this.scrollToBottomInitial();
      if (tag === "yes") {
        setTimeout(() => {
          const messages = [
            ...this.state.messages,
            { ...initialMessages[2] },
            { ...initialMessages[3] },
          ];
          this.setState({ messages: messages }, () => {
            this.scrollToBottomInitial();
            setTimeout(() => {
              const messages = [
                ...this.state.messages,
                { ...initialMessages[4] },
              ];
              this.setState({ messages: messages, loading: false }, () =>
                this.scrollToBottomInitial()
              );
            }, 1000);
          });
        }, 500);
        this.enableInput();
      } else {
        this.scrollToBottomInitial();
        const messages = [
          ...this.state.messages,
          {
            id: 10,
            question:
              "I have noted your response. Please start this questionaire whenever you are ready.",
            fields: [],
            answer: null,
          },
        ];
        setTimeout(() => {
          this.setState({ messages: messages, loading: false }, () =>
            this.scrollToBottomInitial()
          );
        }, 1000);

        this.disableInput();
      }
    });
  };
  handleMultipleBubble = (e) => {
    let answerStr = "";
    let answertag = "";
    this.state.messages[this.state.messages.length - 1].fields.forEach(
      (ele) => {
        if (ele.selected === true) {
          answerStr =
            answerStr.length > 0
              ? answerStr + "," + ele.text
              : answerStr + ele.text;
          answertag =
            answertag.length > 0
              ? answertag + "," + ele.tag
              : answertag + ele.tag;
        }
      }
    );
    let slug = localStorage.getItem("slug");
    let params = {
      id: this.state.messages[this.state.messages.length - 1].id,
      answer: answerStr,
      answerTag: answertag,
    };

    this.chatBotService.submitAnswer(
      slug,
      params,
      (res) => {
        let msgList = this.state.messages.map((ele) => {
          return { ...ele };
        });
        let lastMsg = { ...msgList[msgList.length - 1] };
        lastMsg.answer = res.answer;
        msgList.pop();

        let cheery = this.getCheeryMessages(params);
        lastMsg.cheery = cheery;
        msgList.push(lastMsg);
        this.setState({ messages: [...msgList] }, () => this.getNext());
      },
      (err) => {
        console.log("cannot submit the answer");
      }
    );
  };
  getCheeryMessages = (params) => {
    console.log("params is ", params);
    let cheery = null;
    if (params.id === 5) {
      cheery =
        "Thank you for providing the details. Next set of questions are around your lifestyle - physical activity, dietary habits and sleep. Try and answer them as honestly as you can :)";
    } else if (params.id === 15) {
      cheery =
        "This was super helpful. I have few questions to understand your emotional well-being better.";
    } else if (params.id === 18) {
      cheery =
        "We are almost done! My next set of questions are on your medical and family history.";
    } else if (params.id === 26) {
      cheery =
        "Thank you for filling the questionaire. Last set of questions are on you health literacy and your perception of your health.";
    } else if (params.id === 22) {
      cheery =
        "Do your parents suffer(ed) from any of the following health concerns? (select all that are applicable)";
    }
    console.log("returning cheery message", cheery);
    return cheery;
  };
  produceFieldOutput = (fields, msg) => {
    let answerBubbles = [];
    this.placeholder = "Type Here";
    let isInput = false;
    let myVal = false;

    if (msg.type === 1 || msg.type === 2 || msg.type === 3) {
      fields.forEach((ele) => {
        if (ele.type === 1) {
          // this.enableInput();

          this.validation = ele.validate;
          this.inputTag = ele.tag;
          this.placeholder = ele.placeholder;
          isInput = true;
        } else {
          let Obj = {};
          Obj.text = ele.text;
          Obj.tag = ele.tag;
          answerBubbles.push(Obj);
        }
      });

      if (answerBubbles.length > 0) {
        return (
          <div className="bubble-left-message">
            {answerBubbles.map((bubble) => {
              return (
                <div
                  id={bubble.tag}
                  className="bubble-messages button-bubble-bounce"
                  onClick={
                    localStorage.getItem("slug") !== null
                      ? (e) => this.handleBubbleMessage(e, bubble.tag)
                      : () => this.handleInitialBubbleMessage(bubble.tag)
                  }
                >
                  {bubble.text}
                </div>
              );
            })}
          </div>
        );
      }
    } else if (msg.type === 4) {
      fields.forEach((ele) => {
        if (ele.type === 1) {
          // this.enableInput();
          this.validation = ele.validate;
          this.inputTag = ele.tag;
          this.placeholder = ele.placeholder;
          isInput = true;
        } else {
          let Obj = {};
          Obj.text = ele.text;
          Obj.tag = ele.tag;
          if (ele.selected) {
            Obj.selected = ele.selected;
          } else {
            Obj.selected = false;
            ele.selected = false;
          }
          answerBubbles.push(Obj);
        }
      });

      if (answerBubbles.length > 0) {
        return (
          <div className="bubble-left-message">
            {answerBubbles.map((bubble) => {
              return (
                <div
                  id={bubble.tag}
                  className={`bubble-messages button-bubble-bounce ${
                    bubble.selected === true ? "selected-bubble-class" : ""
                  }`}
                  onClick={() => {
                    console.log("current msg state is ", msg);
                    let msgList = this.state.messages.map((e) => {
                      return { ...e };
                    });
                    let enableDone = false;
                    let newFields = this.state.messages[
                      this.state.messages.length - 1
                    ].fields.map((ele) => {
                      if (ele.tag === bubble.tag) {
                        let modObj = { ...ele };
                        if (modObj.selected) {
                          modObj.selected = !modObj.selected;
                        } else {
                          enableDone = true;
                          modObj.selected = true;
                        }

                        return { ...modObj };
                      } else {
                        if (bubble.tag === "none_of_the_above") {
                          return { ...ele, selected: false };
                        } else if (ele.tag === "none_of_the_above") {
                          if (ele.selected && ele.selected === true) {
                            return { ...ele, selected: false };
                          }
                        }
                        if (ele.selected) {
                          enableDone = true;
                        }
                        return { ...ele };
                      }
                    });
                    let newLastObj = {
                      ...this.state.messages[this.state.messages.length - 1],
                    };
                    newLastObj.fields = [...newFields];
                    newLastObj.enableDone = enableDone;
                    msgList.pop();
                    msgList.push(newLastObj);
                    this.setState({ messages: [...msgList] });
                  }}
                >
                  {bubble.text}
                </div>
              );
            })}
            <div
              className={`bubble-messages button-bubble-bounce ${
                this.state.messages[this.state.messages.length - 1]
                  .enableDone === true
                  ? "enable-done-button"
                  : "disable-done-button"
              }`}
              onClick={(e) => {
                if (
                  this.state.messages[this.state.messages.length - 1].enableDone
                ) {
                  this.handleMultipleBubble(e);
                } else {
                  this.handleError("Please select a valid option first");
                }
              }}
            >
              Done
            </div>
          </div>
        );
      }
    } else {
    }
    // for (let i = 0; i < fields.length; i++) {
    //   if (fields[i].type == 1) {
    //     myVal = true;
    //     break;
    //   }
    // }
    // if (myVal) {
    //   this.setState({ isInput: true });
    // } else {
    //   this.setState({ isInput: false });
    // }
  };

  render() {
    return (
      <div className="App" id="app">
        <RequestCallback
          open={this.state.showRequestCallback}
          handleClose={() => this.setState({ showRequestCallback: false })}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
            minHeight: "72px",
          }}
        >
          <header className="App-header">
            <div className="logo-wrapper">
              <img src={logo} className="App-logo" alt="logo" />
            </div>
            <div
              className="health-score"
              onClick={() => this.setState({ showRequestCallback: true })}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23 1L15.6667 8.33333L23 1ZM15.6667 8.33333V2.22222V8.33333ZM15.6667 8.33333H21.7778H15.6667ZM3.44444 1C2.79614 1 2.17438 1.25754 1.71596 1.71596C1.25754 2.17438 1 2.79614 1 3.44444V4.66667C1 14.7916 9.20844 23 19.3333 23H20.5556C21.2039 23 21.8256 22.7425 22.284 22.284C22.7425 21.8256 23 21.2039 23 20.5556V16.5467C22.9998 16.2903 22.919 16.0404 22.7689 15.8325C22.6189 15.6245 22.4073 15.469 22.164 15.388L16.6726 13.5571C16.3935 13.4643 16.0903 13.4753 15.8187 13.588C15.547 13.7007 15.3251 13.9076 15.1937 14.1707L13.8126 16.9292C10.8197 15.5768 8.4227 13.1793 7.07078 10.1862L9.82933 8.80755C10.0924 8.67611 10.2993 8.45421 10.412 8.18257C10.5247 7.91092 10.5357 7.60775 10.4429 7.32867L8.612 1.83478C8.5307 1.59153 8.37494 1.38003 8.16677 1.23021C7.95861 1.08039 7.70858 0.999853 7.45211 1H3.44444Z"
                  stroke="#EF7C01"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <span>
                Request <br />
                Callback
              </span>
            </div>
          </header>
          {this.state.hasError && (
            <div className="error-message">{this.state.errorMessage}</div>
          )}
        </div>

        <div className="message-box" ref={this.msgBox}>
          {this.state.messages.map((msg) => {
            return (
              <>
                <div className="left-message">{msg.question}</div>
                {msg.answer === null &&
                  this.produceFieldOutput(msg.fields, msg)}

                {msg.answer !== null && msg.type !== 5 && (
                  <div className="right-message">{msg.answer}</div>
                )}
                {msg.cheery && <div className="left-message">{msg.cheery}</div>}
              </>
            );
          })}
          {this.state.loading && <Loading />}
          <div
            ref={this.messagesEnd}
            style={{ minHeight: "5px", marginTop: "5px" }}
            className="last-message"
          />
        </div>
        <div style={{ height: "68px", position: "relative" }}>
          <div className="footer">
            <button
              className="undo"
              disabled={
                this.state.messages.length > 2 &&
                this.state.messages[this.state.messages.length - 2].undo !==
                  null
                  ? false
                  : true
              }
              onClick={() => {
                this.handleUndo();
              }}
              id="undo"
            >
              <img src={undo} alt="undo-img" />
            </button>
            <form className="form-class">
              <input
                type="text"
                value={this.state.inputValue}
                placeholder={this.placeholder}
                onChange={(e) => this.handleInput(e)}
                className="message-input"
                id="my-input-box"
                disabled={true}
                onFocus={() => this.scrollOnFocus()}
              />
              <button
                type="submit"
                onClick={(e) => this.sendMessage(e)}
                className="send-button"
              >
                <img src={send} alt="send-img" id="send-img" />
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(App);
